import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { NotificationsService } from 'src/app/services/notifications.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { User } from 'src/app/models/administration/user';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { EmergingActivity } from 'src/app/models/maintenance/emerging-activities';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-fuel-requests',
    templateUrl: './fuel-requests.component.html',
    styleUrls: ['./fuel-requests.component.scss'],
    standalone: false
})
export class FuelRequestsComponent implements OnInit {

  public urlTablaEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`
  private urlComboEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`
  private urlGetComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`
  private urlPostActividad: string = `${EndpointDictionary.ActivityeEmerg.CRUD_ACTIVITY_EMERG_DATA}`

  private rol: string

  public equipo: Equipment = {}
  public formStepeOne: UntypedFormGroup
  public formStepeTwo: UntypedFormGroup
  private comboUsuarios: Array<User> = []
  public movil: boolean
  public labels: Array<string> = []
  //tabla equipos

  recargarTablaEquipos = new EventEmitter<any>()
  public dataEquipos: Array<Equipment>
  configurationEquipos: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id'
  }
  public columnasEquipos: TableColumns<Equipment>[] = [
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',

      },
    }
  ]

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Solicitudes combustible",
      current: true
    }]

  constructor(
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    public notificationService: NotificationsService,
    private storage: LocalStorageService,
    private session : SessionService
  ) {
    this.rol = this.storage.get<string>('rol');
    this.formStepeOne = this.formBuilder.group({
      equipmentId: '',
    }),
      this.formStepeTwo = this.formBuilder.group({
        date: '',
      })
  }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
    this.init()
  }

  canCreateRequest():boolean{
    var canCreateRequest = true;
    const fuelOrderCount = this.session.getData('fuelOrderCount') || 0;
    if (fuelOrderCount >= environment.createMaxDemandOF) {
      canCreateRequest = false;
      this.message.Warning('Advertencia', `No puedes crear más solicitudes, tienes más de ${environment.createMaxDemandOF} órdenes en curso, debes cerrarlas para poder crear más solicitudes.`)
      .then(() => {
        this.router.navigate(['/combustible/autoriza_comb'])
      }); 
     } 

     return canCreateRequest
  }

  async init() {

    try {
      let res: Array<Equipment> = await this.http.getDataBody(`${this.urlComboEquipos}`)
      if (res) {
        let element: Equipment = res.find(x => x.userId == this.storage.get<number>('userId'))
        if (element && element.state) {
          this.clickFilaEquipos(element)
        }
      }
    } catch (error) {
      this.message.Error('Error', error)
    }
    try {
      let res: Array<User> = await this.http.getDataBody(`${this.urlGetComboUsuarios}`)

      if (res) {
        this.comboUsuarios = res
      }
    } catch (error) {
      this.message.Error('Error', error)
    }
  }

  async clickFilaEquipos($event: Equipment) {
    if(!this.canCreateRequest()) return
    this.equipo = $event
    this.labels = [`Código del equipo: ${this.equipo.code}`]
    this.formStepeOne.get('equipmentId').setValue(this.equipo.id)
  }

  async form(data: {date: Date}) {
    if(!this.canCreateRequest()) return
    this.message.openLoading("Cargando", "Enviando Solicitud")
    let form: EmergingActivity = {
      description: "Solicitud de combustible",
      cost: 0,
      requests: this.storage.get<number>('userId'),
      equipmentId: this.formStepeOne.get('equipmentId').value,
      date: this.functions.dateForm(data.date),
      maintenanceType: "Combustible"
    }
    
      let actividad: GenericResponse = await this.http.postDataBody(`${this.urlPostActividad}`, form)
      if (actividad) {
        let id_solicitud = actividad.insertId
        let descripcion = `Equipo : ${this.equipo.code}`

        if (this.rol != 'Jefe Mantenimiento') {
          await this.notificationService.sendNotificationFuelRequestQueue(descripcion, id_solicitud)
        }

        await this.notificationService.sendNotificationAutorizeFuelRequest(descripcion, id_solicitud)

        this.message.closeLoading()
        this.message.SuccessToast('Solicitud de combustible creada correctamente')
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);
      } else {
        this.message.Error('Error', actividad['message'])
        this.message.closeLoading()
      }
  }

  checkDateRange($event: Date) {
    let mesH;
    let mesUser;
    let hoy = new Date();
    let date = new Date($event);
    let year = hoy.getFullYear() - date.getFullYear();
    let month = date.getMonth() - hoy.getMonth();
    let day = date.getDate() - hoy.getDate();

    switch (hoy.getMonth()) {
      case 0:
        mesH = 'Enero';
        break;
      case 1:
        mesH = 'Febrero';
        break;
      case 2:
        mesH = 'Marzo';
        break;
      case 3:
        mesH = 'Abril';
        break;
      case 4:
        mesH = 'Mayo';
        break;
      case 5:
        mesH = 'Junio';
        break;
      case 6:
        mesH = 'Julio';
        break;
      case 7:
        mesH = 'Agosto';
        break;
      case 8:
        mesH = 'Septiembre';
        break;
      case 9:
        mesH = 'Octubre';
        break;
      case 10:
        mesH = 'Noviembre';
        break;
      case 11:
        mesH = 'Diciembre';
        break;
      default:
        break;
    }
    switch (date.getMonth()) {
      case 0:
        mesUser = 'Enero';
        break;
      case 1:
        mesUser = 'Febrero';
        break;
      case 2:
        mesUser = 'Marzo';
        break;
      case 3:
        mesUser = 'Abril';
        break;
      case 4:
        mesUser = 'Mayo';
        break;
      case 5:
        mesUser = 'Junio';
        break;
      case 6:
        mesUser = 'Julio';
        break;
      case 7:
        mesUser = 'Agosto';
        break;
      case 8:
        mesUser = 'Septiembre';
        break;
      case 9:
        mesUser = 'Octubre';
        break;
      case 10:
        mesUser = 'Noviembre';
        break;
      case 11:
        mesUser = 'Diciembre';
        break;
      default:
        break;
    }

    if (year != 0) {
      if (year == -1 && hoy.getMonth() == 11) {
        console.log(
          `Mantenimiento programado para el año ${date.getFullYear()}`
        );
      } else {
        this.message.Warning(
          'Advertencia',
          `Estamos en el año ${hoy.getFullYear()} y la fecha de esta orden está para el año ${date.getFullYear()}`
        );
      }
    } else {
      if (month > 0) {
        if (month == 1) {
          day = Math.abs(hoy.getDate() - date.getDate() - 30);
          console.log('dia', day);
          if (day > 15) {
            this.message.Warning(
              'Advertencia',
              `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser}`
            );
          }
        } else {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser}`
          );
        }
      } else {
        if (month < 0) {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser} que ya pasó`
          );
        }
      }
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos')
  }
}
